var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"type":"text","size":"mini","disabled":_vm.isdisabled},on:{"input":_vm.getVal},model:{value:(_vm.inputval),callback:function ($$v) {_vm.inputval=$$v},expression:"inputval"}})}
var staticRenderFns = []

export { render, staticRenderFns }